module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-friesland.svg?4f2935af547f35d80924b2a325f8ccfe";